import './TextCard.scss';
import { Input } from 'antd';
import { RxCross2 } from 'react-icons/rx';
import React from 'react';
import TextArea from 'antd/lib/input/TextArea';
import { t } from '../../../i18n/i18n';
import NewStyleSelect from '../../NewStyleSelect/NewStyleSelect';
import { maxRecordTimes } from '../../../constants/questions';
import { isAiInterviewStrategy } from '../../../utils/testgroups';
import { StrategyValues } from '../../../constants/enums';

function TextCard({
  index,
  question,
  maxChar,
  concepts,
  handleDelete,
  id,
  setDataAI,
  textAIType,
  strategy = StrategyValues.NORMAL,
  totalTime,
}) {
  const handleUpdateData = (e, id) => {
    let { name, value, type } = e.target;

    if (type === 'number') {
      value = Number(value);
    }

    setDataAI((prevState) =>
      prevState.map((item) => (item.id === id ? { ...item, [name]: value } : item))
    );
  };
  return (
    <div className="text-card-container">
      <div className="text-card-index-badge">
        <span>{index}</span>
      </div>
      <div className="text-card-content">
        <div className="text-card-fields">
          <span className="card-text">{t('WRITE_CART_SUBTITLE_QUESTION')}: </span>
          <TextArea
            name="question"
            className={`text-card-textarea ${
              question.length ? 'selected-border' : 'unselected-border'
            }`}
            rows="4"
            placeholder={t('CREATE_SCREENING_YOUR_QUESTIONS_WRITE_YOU_QUESTION_PLACEHOLDER')}
            onChange={(e) => handleUpdateData(e, id)}
            value={question ?? ''}
            maxLength={5000}
            data-testid="question-text-textarea"
          />

          <div className="text-card-max-char-wrapper">
            {isAiInterviewStrategy(strategy) ? (
              <div
                data-testId="question-video-answer-total-time"
                className="justify-content-start d-flex flex-column w-100"
              >
                <span className="card-text">{t('CREATE_SCREENING_TOTAL_RECORD_TIME')}</span>
                <div>
                  <NewStyleSelect
                    error={false}
                    className="w-100 mb-4"
                    value={totalTime ?? maxRecordTimes[maxRecordTimes?.length - 1].id}
                    options={maxRecordTimes}
                    onChange={(e) => {
                      handleUpdateData(e, id);
                    }}
                    name="totalTime"
                    borderClasses="bottom-border text-center"
                  />
                </div>
              </div>
            ) : (
              <>
                <span className="card-text">{t('CREATE_PREFILTER_MAX_CHAR_ANSWER')}:</span>
                <Input
                  type="number"
                  name="maxChar"
                  value={maxChar ?? ''}
                  onKeyDown={(e) => {
                    const excludedKeys = ['e', '+', '-', '.'];
                    if (excludedKeys.includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => handleUpdateData(e, id)}
                  className="text-card-max-char-input"
                  min={0}
                  max={5000}
                  data-testid="question-text-max-char-input"
                  placeholder={t('CREATE_SCREENING_MAX_CHAR_ANSWER')}
                />
              </>
            )}

            {textAIType && (
              <>
                <span className="card-text">{t('TEXT_SPAN_CONCEPTS_MODAL_AI_SUGESTION')}:</span>
                <TextArea
                  name="concepts"
                  className="text-card-textarea-concepts"
                  rows="3"
                  onChange={(e) => handleUpdateData(e, id)}
                  value={concepts ?? ''}
                  maxLength={5000}
                  data-testid="question-text-textarea"
                />
              </>
            )}
          </div>
        </div>
      </div>
      <div className="text-card-remove">
        <RxCross2 onClick={() => handleDelete(id)} />
      </div>
    </div>
  );
}

export default TextCard;
